var _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleted(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "13px",
    height: "16px",
    viewBox: "0 0 13 16",
    enableBackground: "new 0 0 13 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "added",
    display: "none"
  }, /*#__PURE__*/React.createElement("polygon", {
    display: "inline",
    fill: "#8DC02E",
    points: "6.5,9 6.5,12 4.5,12 4.5,9 1.5,9 1.5,7 4.5,7 4.5,4 6.5,4 6.5,7 9.5,7 9.5,9  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "reserved",
    display: "none"
  }, /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#8DC02E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 5.5,
    y1: 0,
    x2: 5.5,
    y2: 16
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "not_reserved",
    display: "none"
  }, /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#D5D6D9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 5.5,
    y1: 0,
    x2: 5.5,
    y2: 16
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "locked",
    display: "none"
  }, /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#D5D6D9",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 5.5,
    y1: 0,
    x2: 5.5,
    y2: 16
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#D5D6D9",
    strokeWidth: 0.7125,
    strokeMiterlimit: 10,
    d: "M7.985,5.067c0,0-0.125-3.384,2.015-3.392 c2.113-0.007,2.05,2.653,2.022,3.392"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D5D6D9",
    d: "M11.9,8.325H8.1L7.625,7.85V5h4.75v2.85L11.9,8.325z M10,5.544C9.792,5.547,9.763,5.97,9.763,6.495 c0,0.524-0.03,1.422,0.237,1.425c0.305,0.003,0.237-0.901,0.237-1.425C10.237,5.97,10.245,5.542,10,5.544z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "modified",
    display: "none"
  }, /*#__PURE__*/React.createElement("line", {
    display: "inline",
    fill: "none",
    stroke: "#29ABDF",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 5.5,
    y1: 0,
    x2: 5.5,
    y2: 16
  }), /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#29ABDF",
    d: "M2.005,8.044c-0.255,0-0.466-0.078-0.632-0.233C1.207,7.655,1.125,7.467,1.125,7.246 c0-0.231,0.084-0.419,0.25-0.566c0.168-0.148,0.377-0.222,0.63-0.222c0.255,0,0.464,0.075,0.627,0.224 c0.163,0.149,0.244,0.337,0.244,0.564c0,0.23-0.081,0.421-0.241,0.572C2.473,7.968,2.263,8.044,2.005,8.044z M2.79,1.044 L2.603,5.79H1.378L1.201,1.044H2.79z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "deleted"
  }, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D53C39",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    x1: 5.5,
    y1: 0,
    x2: 5.5,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#D53C39",
    strokeMiterlimit: 10,
    x1: 3,
    y1: 5.168,
    x2: 0,
    y2: 5.168
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleted);
export default __webpack_public_path__ + "static/media/deleted.92b4ae21995ec0552c61008ef488c68d.svg";
export { ForwardRef as ReactComponent };